<template>
    <div class="relative mx-auto shadow-md rounded-md" style="min-width:400px; max-width: 400px;"
    >
        <canvas
            id="canvas"
            class="relative"
            style="z-index: 1"
        ></canvas>
    </div>
</template>

<script>
import { ref } from '@vue/reactivity';
import { onMounted, onUnmounted, watch } from '@vue/runtime-core';

const size = {
    width: 400,
    height: 400,
}

export default {
    props: {
        readOnly: Boolean,
        image: [String],
        area: [Array, Object],
    },

    setup(props, { emit }) {

        // Variables
        const
            ctx = ref(null),
            canvas = ref(null),
            refresh = ref(true),
            storedRects = ref([]),
            request = ref(null);

        const mouse = {
            button : false,
            x : 0,
            y : 0,
            down : false,
            up : false,
            element : null,
            event(e) {
                const m = mouse;
                if(e.target.id == 'canvas') {
                    m.bounds = m.element.value.getBoundingClientRect();
                    m.x = e.pageX - m.bounds.left - scrollX;
                    m.y = e.pageY - m.bounds.top - scrollY;
                    const prevButton = m.button;

                    m.button = e.type === "mousedown" ? true : e.type === "mouseup" ? false : mouse.button;
                    if (!prevButton && m.button) { m.down = true }
                    if (prevButton && !m.button) { m.up = true }
                }
            },
            start(element) {
                mouse.element = element;
                "down,up,move".split(",").forEach(name => document.addEventListener("mouse" + name, mouse.event));
            }
        }

        onMounted(() => {
            canvas.value = document.getElementById('canvas');
            ctx.value = canvas.value.getContext('2d');

            ctx.value.canvas.width = size.width;
            ctx.value.canvas.height = size.height;

            if(props.area) {
                if(props.area.area) {
                    storedRects.value = props.area.area;
                }
                else storedRects.value = props.area;
                draw();
            }
            if(props.readOnly == false) request.value = requestAnimationFrame(mainLoop);
        });

        watch(() => props.area, (val, oldVal) => {
            if(val.area) {
                storedRects.value = val.area;
            }
            else storedRects.value = val;
            draw();
        });

        onUnmounted(() => {
            cancelAnimationFrame(request.value);
        });

        const
            loadImage = (url) => {
                const image = new Image();
                image.src = url;
                image.onload = () => refresh.value = true;
                return image;
            },
            draw = () => {
                ctx.value.drawImage(baseImage, 0, 0, ctx.value.canvas.width, ctx.value.canvas.width);
                ctx.value.lineWidth = 1;
                ctx.value.strokeStyle = "#111827";

                if(Array.isArray(storedRects.value)) storedRects.value.forEach(rect => rect.draw(ctx.value));
                else {
                    ctx.value.fillStyle = "rgb(127, 127, 127, 0.3)";
                    ctx.value.fillRect(storedRects.value.x, storedRects.value.y, storedRects.value.w, storedRects.value.h);
                    ctx.value.strokeRect(storedRects.value.x, storedRects.value.y, storedRects.value.w, storedRects.value.h)
                }

                ctx.value.strokeStyle = "yellow";
                rect.draw(ctx.value);
            };

        const baseImage = loadImage(props.image);
        const rect = (() => {

            var x1, y1, x2, y2;
            var show = false;

            function fix() {
                rect.x = Math.min(x1, x2);
                rect.y = Math.min(y1, y2);
                rect.w = Math.max(x1, x2) - Math.min(x1, x2);
                rect.h = Math.max(y1, y2) - Math.min(y1, y2);
            }

            function draw(ctx) {
                ctx.fillStyle = "rgb(127, 127, 127, 0.3)";
                ctx.fillRect(this.x, this.y, this.w, this.h);
                ctx.strokeRect(this.x, this.y, this.w, this.h)
            }

            const rect = { x : 0, y : 0, w : 0, h : 0,  draw };

            const API = {
                restart(point) {
                    x2 = x1 = point.x;
                    y2 = y1 = point.y;
                    fix();
                    show = true;
                },
                update(point) {
                    x2 = point.x;
                    y2 = point.y;
                    fix();
                    show = true;
                },
                toRect() {
                    show = false;
                    return Object.assign({}, rect);
                },
                draw(ctx) {
                    if (show) { rect.draw(ctx) }
                },
                show : false,
            }
            return API;
        })();

        if(props.readOnly == false) mouse.start(canvas);

        function mainLoop(){
            if (refresh.value || mouse.down || mouse.up || mouse.button) {
                refresh.value = false;
                if (mouse.down && props.readOnly == false) {
                    mouse.down = false;

                    storedRects.value = {};
                    rect.restart(mouse);
                } else if (mouse.button && props.readOnly == false) {

                    rect.update(mouse);
                } else if (mouse.up && props.readOnly == false) {

                    mouse.up = false;
                    rect.update(mouse);

                    storedRects.value = rect.toRect();

                    emit('update-area', storedRects.value)
                }

                if(props.readOnly == false) draw();
            }
            if(props.readOnly == false) request.value = requestAnimationFrame(mainLoop)
        }

        return {
            ctx,
            canvas,

            storedRects,
            draw
        }
    },

    watch: {
        '$props.area': {
            handler(val, oldVal) {
                this.draw();
            },
            deep: true
        },
    }
}
</script>
